export function isColumnSortable(column) {
  return column.compare.length > 0;
}